import { render, staticRenderFns } from "./CreateClaimOrDispute.vue?vue&type=template&id=3d130c4c&scoped=true"
import script from "./CreateClaimOrDispute.vue?vue&type=script&lang=js"
export * from "./CreateClaimOrDispute.vue?vue&type=script&lang=js"
import style0 from "./CreateClaimOrDispute.vue?vue&type=style&index=0&id=3d130c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d130c4c",
  null
  
)

export default component.exports